@if (loading()) {
  <div
    class="h-full w-full animate-pulse rounded-xl bg-gray-100 dark:bg-gray-800"
    data-testid="garage-signature-loading"
  ></div>
} @else if (imageUrl(); as url) {
  <div class="flex h-full w-full flex-1 flex-col">
    <div
      class="relative flex w-full flex-1 items-center justify-center overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-gray-600"
    >
      <img
        [src]="url"
        alt="Unterschrift"
        class="block h-full w-auto max-w-full object-contain px-6 py-3"
        data-testid="garage-signature-image"
      />
    </div>
    @if (!readonly()) {
      <div class="mt-2 flex justify-end">
        <soft-ds-button
          variant="secondary"
          size="lg"
          (click)="openSignatureModal()"
          data-testid="garage-signature-resign"
        >
          Erneut unterschreiben
          <ng-template softSlot="leading">
            <soft-ds-icon name="fa-regular fa-pen" />
          </ng-template>
        </soft-ds-button>
      </div>
    }
  </div>
} @else if (readonly()) {
  <div
    class="flex min-h-44 w-full flex-1 flex-col items-center justify-center gap-2 rounded-xl border border-dashed border-gray-300 text-gray-400 dark:border-gray-600 dark:text-gray-500"
  >
    <soft-icon name="fa-regular fa-signature" class="text-lg" />
    <span class="text-sm">Keine Unterschrift vorhanden</span>
  </div>
} @else {
  <button
    type="button"
    class="signature-empty flex min-h-44 w-full flex-1 cursor-pointer flex-col items-center justify-center gap-2.5 rounded-xl border-2 border-dashed border-gray-300 bg-gray-50/50 text-gray-500 transition-colors dark:border-gray-600 dark:bg-gray-800/40 dark:text-gray-400"
    (click)="openSignatureModal()"
    data-testid="garage-signature-open"
  >
    <span
      class="signature-empty-icon flex h-11 w-11 items-center justify-center rounded-full bg-gray-100 transition-colors dark:bg-gray-700"
    >
      <soft-icon name="fa-regular fa-signature" />
    </span>
    <span class="text-sm font-medium">Tippen Sie hier, um zu unterschreiben</span>
    <span class="text-xs text-gray-400 dark:text-gray-500">
      Mit Finger, Stift oder Maus
    </span>
  </button>
}
